import { render, staticRenderFns } from "./dingjwk_public_config.vue?vue&type=template&id=b3721ad2&scoped=true&"
import script from "./dingjwk_public_config.vue?vue&type=script&lang=js&"
export * from "./dingjwk_public_config.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3721ad2",
  null
  
)

export default component.exports